import KmxBankStroked from '@kmx/mui-icons/KmxBankStroked';
import KmxCarBowStroked from '@kmx/mui-icons/KmxCarBowStroked';
import KmxChatStroked from '@kmx/mui-icons/KmxChatStroked';
import KmxDollarBillStroked from '@kmx/mui-icons/KmxDollarBillStroked';
import KmxLockClosedStroked from '@kmx/mui-icons/KmxLockClosedStroked';
import KmxSalesTagStroked from '@kmx/mui-icons/KmxSalesTagStroked';
import KmxSearchStroked from '@kmx/mui-icons/KmxSearchStroked';
import KmxShieldCheckStroked from '@kmx/mui-icons/KmxShieldCheckStroked';
import KmxStoreStroked from '@kmx/mui-icons/KmxStoreStroked';
import KmxWarningStroked from '@kmx/mui-icons/KmxWarningStroked';

interface FaqIconProps {
    title: string;
}

const iconMap: Record<string, JSX.Element> = {
    ['finding a car']: <KmxSearchStroked />,
    ['warranties & more']: <KmxShieldCheckStroked />,
    ['security']: <KmxLockClosedStroked />,
    ['making payments']: <KmxDollarBillStroked />,
    ['selling a car']: <KmxSalesTagStroked />,
    ['financing']: <KmxBankStroked />,
    ['seeing a car']: <KmxStoreStroked />,
    ['buying a car']: <KmxCarBowStroked />,
    ['safety recalls']: <KmxWarningStroked />,
    ['skye']: <KmxChatStroked />,
};

const FaqIcon = ({ title }: FaqIconProps) => {
    const lowerCaseTitle = title.toLowerCase();
    return iconMap[lowerCaseTitle] ?? <></>;
};

export default FaqIcon;
